import styled from "styled-components";

export const Container = styled.div<{ bgImageUrl?: string }>`
	position: relative;
	min-height: 60vh;
	width: 100%;
	background-image: url(${(props) => props.bgImageUrl});
	background-size: cover;
	background-position: left;
	background-repeat: no-repeat;

	@media (orientation: landscape) {
		min-height: 80vh;
		background-position: center;
	}
`;

export const NoFriendsContent = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 65vh;
	width: 100%;

	@media (orientation: landscape) {
		min-height: 80vh;
		background-position: center;
	}
`;

export const CardWrapper = styled.div`
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
`;
